$.fn.scroller = function (customOptions) {
	if (!$(this).length) return false;

	let staticClone;
	const instance = $(this);
	const instanceClass = "sb-instance-" + getPseudoGuid();
	const cloneClass = "sb-clone-" + getPseudoGuid();
	const options = Object.assign({}, {
		useStaticClone: false,
		showCloneBelow: null,
		showCloneAbove: null,
		cloneDisplayProp: "block",
		buttonColor: "blue",
		scrollAmountModifier: 24,
		cb: null
	}, customOptions);
	
	if (options.useStaticClone) {
		staticClone = instance.clone(false);
		staticClone.addClass(cloneClass).removeClass("sb-scroller").removeAttr("data-scroller-id").removeAttr("data-simplebar").removeAttr("id");
		staticClone.find(".sb-scroller__item").removeClass("sb-scroller__item");
		staticClone.insertAfter(instance);
	}

	instance.addClass(instanceClass);

	addStyleBlock(options);

	initialize(instance, options);

	$(window).on("load resize orientationchange", function(){
		initialize(instance, options);

		if (options.cb && typeof options.cb == 'function') {
			options.cb();
		}
	});

	function initialize(inst, opts) {
		if (opts.useStaticClone) {
			if (opts.showCloneAbove) {
				if (window.matchMedia(`(min-width: ${opts.showCloneAbove}px)`).matches) {
					return false;
				}	
			}

			if (opts.showCloneBelow) {
				if (window.matchMedia(`(max-width: ${opts.showCloneBelow}px)`).matches) {
					return false;
				}
			}
		}

		if (!inst.data("simplebar")) {
			const simpleBar = new SimpleBar(inst[0]);

			addArrowsHTML(inst, opts);

			inst.on('click', function (e) {
				if (e.target.matches('.simplebar-arrow')) {
					handleArrowClick(e, opts);
				}
			});
		}
	}

	function addStyleBlock(opts) {
		const styleBlockId = "id-" + instanceClass;
		const styleBlockExists = document.getElementById(styleBlockId);

		if (!styleBlockExists && opts.useStaticClone && instanceClass && cloneClass) {
			let styleBlock = $('<style id="' + styleBlockId + '" />');
			let displayProp = opts.cloneDisplayProp;

			styleBlock.html(`
				.${cloneClass} {
					display: none !important;
				}
				.${instanceClass} {
					display: block !important;
				}
			`);

			if (opts.showCloneAbove) {
				styleBlock.html(styleBlock.html() + `
					@media (min-width: ${opts.showCloneAbove}px) {
						.${cloneClass} {
							display: ${displayProp} !important;
						}
						.${instanceClass} {
							display: none !important;
						}
					}
				`);
			}

			if (opts.showCloneBelow) {
				styleBlock.html(styleBlock.html() + `
					@media (max-width: ${opts.showCloneBelow}px) {
						.${cloneClass} {
							display: ${displayProp} !important;
						}
						.${instanceClass} {
							display: none !important;
						}
					}
				`);
			}

			$("head").append(styleBlock);
		}
	}

	function addArrowsHTML(inst, opts) {
		let arrows, arrowsTemplate;

		arrows = $('<div class="simplebar-arrow-wrap" />');
		arrowsTemplate = `
			<button class="simplebar-arrow arrow-left">
			<span class="icon-wrap"><svg aria-hidden="true" class="icon icon--angle-left-bold icon--${opts.buttonColor}"><use xlink:href="#icon-angle-left-bold"></use></svg></span>
			</button>

			<button class="simplebar-arrow arrow-right">
			<span class="icon-wrap"><svg aria-hidden="true" class="icon icon--angle-right-bold icon--${opts.buttonColor}"><use xlink:href="#icon-angle-right-bold"></use></svg></span>
			</button>`;

		arrows.html(arrowsTemplate);
		arrows.appendTo(inst);
	}

	function handleArrowClick(e, opts) {
		const clicked = $(e.target);
		const scroller = clicked.closest(".sb-scroller");
		let scrollPos;

		if (clicked.hasClass("arrow-left")) {
			scrollPos = {
				scrollLeft: calcScrollAmount(clicked, true) - opts.scrollAmountModifier
			};
		} else if (clicked.hasClass("arrow-right")) {
			scrollPos = {
				scrollLeft: calcScrollAmount(clicked) + opts.scrollAmountModifier
			};
		}

		scroller.find(".simplebar-content-wrapper").stop().animate(scrollPos, 400);

		function calcScrollAmount(clicked, isLeft) {
			const scroller = clicked.closest(".sb-scroller");
			const scrollerItem = scroller.find(".sb-scroller__item");
			const wrapper = scroller.find(".simplebar-content-wrapper");
			const wrapperPos = wrapper.scrollLeft();
			const firstItemWidth = scrollerItem.first().outerWidth();
			return isLeft ? wrapperPos - firstItemWidth : wrapperPos + firstItemWidth
		}
	}
};
